import React, { useCallback, useContext } from 'react'
import { ChainContext } from '@/contexts/SolanaChainContextProvider'
import { PhantomSolanaMobileContext } from '@/contexts/PhantomSolanaMobileContext'
import PhantomIcon from '@/assets/phantom.svg'

type PhantomSolanaMobileConnectButtonProps = {
  onConnectStarted?: () => void
}

export const PhantomSolanaMobileConnectButton = React.memo(
  ({ onConnectStarted }: PhantomSolanaMobileConnectButtonProps) => {
    const { solanaExplorerClusterName } = useContext(ChainContext)
    const { connect } = useContext(PhantomSolanaMobileContext)

    const handleClick = useCallback(() => {
      onConnectStarted?.()
      connect(solanaExplorerClusterName)
    }, [connect, onConnectStarted, solanaExplorerClusterName])

    return (
      <button
        className="w-full justify-start rounded-md p-3 transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
        data-testid="button-wallet-connect-phantom-mobile"
        onClick={handleClick}
        type="button"
      >
        <div className="flex items-center gap-2">
          <img
            src={PhantomIcon}
            alt="Phantom icon"
            className="h-6 w-6"
            data-testid="button-wallet-connect-phantom-mobile-icon"
          />
          <span className="font-medium">Phantom</span>
          <span className="ml-auto text-sm text-gray-500">Open app</span>
        </div>
      </button>
    )
  }
)

PhantomSolanaMobileConnectButton.displayName =
  'PhantomSolanaMobileConnectButton'
